
import { Component, Vue } from "vue-property-decorator";
import { getTotalPrintCount } from "@/api/print";

@Component({
  name: "Form2"
})
export default class extends Vue {
  mounted() {
    this.GetTotalCount();
  }
  private totalcount = "0";
  private GetTotalCount() {
    // this.totalcount = obj_HttpRequest_Core.getTotalPrintCount();
    var printTotalNumResponseStr = getTotalPrintCount();
    var printTotalNumResJson = JSON.parse(printTotalNumResponseStr);
    if (printTotalNumResJson.respcode === "000") {
      this.totalcount = printTotalNumResJson.data;
    } else {
      this.totalcount = "0";
    }
  }
}
